<template>
  <page :loading="loading" style="position: relative">
    <page-error v-if="error" :message="error" />
    <iframe
      v-else-if="authorised"
      ref="application"
      :src="src"
      width="100%"
      height="100%"
      frameborder="0"
      allowtransparency
      @load="iframeLoaded"
    ></iframe>
  </page>
</template>

<script>
import { projectUrl } from '../../../core/helpers'
import Page from '../../../common/components/page/Page'
import RestApi from '../../../core/services/RestApi'
import axios from 'axios'
import PageError from '../../../common/components/page/PageError'

export default {
  name: 'MlStudioApplicationPage',
  components: { PageError, Page },

  data() {
    return {
      loading: true,
      authorised: false,
      error: null,
      url: null
    }
  },

  created() {
    window.addEventListener('message', e => {
      if (e.origin === this.url) {
        if (e.data === 'onContactUsClick') {
          this.$zendesk.show()
          this.$zendesk.open()
          return
        }
        let data = JSON.parse(e.data)
        if (data.location) {
          window.history.pushState(
            null,
            '',
            this.buildStateUrl(data.location.hash)
          )
        }
      }
    })

    RestApi.get(projectUrl('ml-studio/token'))
      .then(({ data }) => {
        this.url = data.url
        this.mlStudioApi
          .post(
            '/api/sso/login',
            { token: data.token },
            { withCredentials: true }
          )
          .then(() => {
            this.authorised = true
          })
          .catch(error => {
            this.loading = false
            this.error = error.message
          })
      })
      .catch(error => {
        this.loading = false
        this.error = error.message
      })
  },

  methods: {
    iframeLoaded() {
      this.loading = false
    },

    buildStateUrl(hash) {
      return '/infinity-ai?project_id=' + this.projectId + hash
    }
  },

  computed: {
    projectId() {
      return this.$route.query.project_id
    },

    mlStudioApi() {
      return axios.create({
        baseURL: this.url
      })
    },

    src() {
      return this.url + window.location.hash + '#/model'
    }
  }
}
</script>

<style scoped>
iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/ml-studio/pages/MlStudioApplicationPage.vue